module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/target-e5e098e54b66a12445c76a358d6220b6.svg";